import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eff7eba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }

import type { PPTTableElement } from '@/types/slides'

import StaticTable from './StaticTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTableElement',
  props: {
    elementInfo: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-table",
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(StaticTable, {
          data: _ctx.elementInfo.data,
          width: _ctx.elementInfo.width,
          cellMinHeight: _ctx.elementInfo.cellMinHeight,
          colWidths: _ctx.elementInfo.colWidths,
          outline: _ctx.elementInfo.outline,
          theme: _ctx.elementInfo.theme
        }, null, 8, ["data", "width", "cellMinHeight", "colWidths", "outline", "theme"])
      ])
    ], 4)
  ], 4))
}
}

})